import script from "./clue.vue?vue&type=script&setup=true&lang=js"
export * from "./clue.vue?vue&type=script&setup=true&lang=js"

import "./clue.vue?vue&type=style&index=0&id=d9880330&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9880330"]])

export default __exports__